import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Footer from "./CommenFooterComponent/index";
import Banner from "../components/Banner/Banner";
import HomeDate from "../components/HomeDate/HomeDate";
import Webinar from "./Webinar/Webinar";
import Readytobegin from "../components/ReadyToBegin/ReadyToBegin";

import jsonData from "./ai-branding.json"; // Import the JSON

export default function Home() {
  const [dpaData, setDPAData] = useState();

  useEffect(() => {
    const fetchdpaJSON = async () => {
      await axios.get(process.env.REACT_APP_HOMEOWNERSHIP_JSON).then(
        (response) => {
          setDPAData(response.data);
          console.log(response.data);
        },
        (error) => {
          console.log(error);
        }
      );
    };

    fetchdpaJSON();
  }, []);

  const [links, setLinks] = useState(null); // Set initial state as null
useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  const sectionRef = useRef(null);

  const scrollToSection = () => {
    const navbarHeight = document.getElementById("navbar").clientHeight; // Adjust 'navbar' with the ID of your navbar
    const sectionTop = sectionRef.current.offsetTop - navbarHeight;
    window.scrollTo({
      top: sectionTop,
      behavior: "smooth",
    });
  };

  if (dpaData) {
    const bannerData = dpaData.banner;
    const homeDate = dpaData.homedateandTime;
    const WebinarHighlightsData = dpaData.WebinarHighlights;
    const readyBegin = dpaData.readyToBegin;
    const disclaimerData = dpaData.fristresponderdisclaimer;

    return (
      <>
        {bannerData ? (
          <Banner bannerData={bannerData} fetchpriority="high" />
        ) : null}

          {homeDate ? (
          <HomeDate homeDate={homeDate} fetchpriority="low" />
        ) : null}
         {WebinarHighlightsData ? (
          <Webinar WebinarHighlightsData={WebinarHighlightsData} fetchpriority="low" />
        ) : null}
          {readyBegin ? (
          <Readytobegin readyBegin={readyBegin} fetchpriority="low" />
        ) : null}
        
         
      
        <Footer fetchpriority="low" links={links.current}/>
      </>
    );
  } else {
    return null;
  }
}
